import { useState } from "react";
import ChatbotLauncher from "./ChatbotLauncher";
import ChatbotPanel from "./ChatbotPanel";
import useChatbotStream from "./useChatbotStream";

export default function ImjaiChatbot() {
  const [open, setOpen] = useState(false);
  const { canRetry, clearMessages, error, liveAssistantMessage, messages, pageContext, pending, pendingSince, retryLastMessage, sendChat, thinkingStep } = useChatbotStream();

  const handlePromptSelect = async (prompt) => {
    setOpen(true);
    await sendChat(prompt);
  };

  const handleClear = () => {
    if (messages.length > 0 && !window.confirm("ล้างบทสนทนาปัจจุบันใช่หรือไม่")) {
      return;
    }

    clearMessages();
  };

  return (
    <>
      <ChatbotPanel
        canRetry={canRetry}
        error={error}
        liveAssistantMessage={liveAssistantMessage}
        messages={messages}
        onClear={handleClear}
        onClose={() => setOpen(false)}
        onPromptSelect={handlePromptSelect}
        onRetry={retryLastMessage}
        onSubmit={sendChat}
        open={open}
        pageContext={pageContext}
        pending={pending}
        pendingSince={pendingSince}
        thinkingStep={thinkingStep}
      />
      <ChatbotLauncher onClick={() => setOpen((current) => !current)} open={open} pending={pending} />
    </>
  );
}